import api from './api';

const permissionService = {
  async listApplications() {
    const { data } = await api.get('/permissions/applications');
    return data; // { success, data: applications[] }
  },

  async listGroups() {
    const { data } = await api.get('/permissions/groups');
    return data; // { success, data: groups[] }
  },

  async createGroup(payload) {
    const { data } = await api.post('/permissions/groups', payload);
    return data; // { success, data: group }
  },

  async updateGroup(id, payload) {
    const { data } = await api.put(`/permissions/groups/${id}`, payload);
    return data; // { success, data: group }
  },

  async deleteGroup(id) {
    const { data } = await api.delete(`/permissions/groups/${id}`);
    return data; // { success }
  },

  async getGroupPermissions(groupId) {
    const { data } = await api.get(`/permissions/group-permissions`, { params: { groupId } });
    return data; // { success, data: permissions[] }
  },

  async updateGroupPermissions(groupId, permissions) {
    const { data } = await api.put(`/permissions/group-permissions`, { groupId, permissions });
    return data; // { success }
  },

  async getMyPermissions() {
    const { data } = await api.get('/permissions/me');
    return data; // { success, data: permissions[] }
  }
};

export default permissionService;